import { Controller } from "@hotwired/stimulus"

// Measures the controller's element (the sticky docs header) and exposes its
// height as the CSS variable `--api-docs-header-height` on <html>.
//
// Combined with `scroll-padding-top: var(--api-docs-header-height)` on <html>,
// this gives anchor-link clicks a scroll target that lands just below the
// sticky header instead of being eaten by it. No magic number required — it
// re-measures on resize (responsive layout, font swap, etc.).
export default class extends Controller {
  connect() {
    this.update()
    this.resizeObserver = new ResizeObserver(() => this.update())
    this.resizeObserver.observe(this.element)

    // On a full page load with a #fragment (docs links cross pages now), the
    // browser scrolls to the anchor before this controller has measured the
    // header, using only the CSS fallback offset. Re-run the scroll with the
    // real offset in place.
    const target = location.hash && document.getElementById(location.hash.slice(1))
    if (target) target.scrollIntoView()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  update() {
    // Add a 1rem (16px) breathing room so the anchor target sits just below the
    // header rather than flush against its bottom edge.
    const height = this.element.getBoundingClientRect().height + 16
    document.documentElement.style.setProperty("--api-docs-header-height", `${height}px`)
  }
}
